const AchievementsDataset =[
    {
        achievementID: "B-1",
        achievementName: "Bronze #1",
        achievementTitle:  "Cash Flow GT $0.",
        earnedAchievementDesc: "Your income was greater than the amount you paid out for 1 month.",
        unearnedAchievementDesc: "Your income must be greater than the amount pay out for 1 month.",
        criteriaArr: [{amount: "0", operation: "GT", dataName: "netIncome", displayName: "cash flow", 
          amountType: "amount"}],
        monthCriteria: {nbrMonths: "1", monthType: "consecutive"},
        link: "monthly-status"
    },
    {
        achievementID: "B-2",
        achievementName: "Bronze #2",
        achievementTitle:  "Opened a Bank and Retirement Savings Account.",
        earnedAchievementDesc: "You opened a bank and retirement savings account and deposited money in the accounts.",
        unearnedAchievementDesc: "Open a bank and retirement savings account and deposit money in each of the accounts. ", 
        criteriaArr: [  
          {amount: "0", operation: "GT", dataName: "bankSavings", displayName: "bank savings amount", 
            displayNA: "bank savings", amountType: "amount"},
          {amount: "0", operation: "GT", dataName: "retirementSavings", displayName: "retirement savings amount",
            displayNA: "retirement savings", amountType: "amount"},
            ],
        monthCriteria:  {nbrMonths: "0", monthType: "none"},
        link: "unlocked-features", linkSelect: "Money Builder"
    },
    {
        achievementID: "B-3",
        achievementName: "Bronze #3",
        achievementTitle:  "Made an Investment",
        earnedAchievementDesc: "You made an investment (purchased a stock, bond, index fund and/or mutual fund).",
        unearnedAchievementDesc: "Make an investment (buy a stock, bond, index fund and/or mutual fund).",
        criteriaArr: [{amount: "0", operation: "GT", dataName: "investments", displayName: "amount invested", 
          displayNA: "investments", amountType: "amount"}],
        monthCriteria: {nbrMonths: "0", monthType: "none"},
        link: "unlocked-features", linkSelect: "Money Builder"
    },
    {
        achievementID: "B-4",
        achievementName: "Bronze #4",
        achievementTitle:  "Paid Off Credit Card for 6 Months",
        earnedAchievementDesc: "You paid off the full credit card amount for 6 months.",
        unearnedAchievementDesc: "Pay off the full credit card balance for 6 months.",
        criteriaArr: [{amount: "0", operation: "EQ", dataName: "creditCardBalance", 
          displayName: "credit card balance", displayNA: "credit card", amountType: "amount"}],
        monthCriteria: {nbrMonths: "6", monthType: "consecutive"},
        link: "unlocked-features", linkSelect: "Credit Card"
    },
    {
        achievementID: "S-1",
        achievementName: "Silver #1",
        achievementTitle:  "Cash Flow Greater than 0 for 2 years.",
        earnedAchievementDesc: "You have earned more than you have spent for 2 years.",
        unearnedAchievementDesc: "Earn more than you spend for 2 years.",
        criteriaArr: [{amount: "0", operation: "GT", dataName: "netIncome", displayName: "cash flow", 
          amountType: "amount"}],
        monthCriteria: {nbrMonths: "24", monthType: "consecutive"},
        link: "monthly-status"
    },
     {
        achievementID: "S-2",
        achievementName: "Silver #2",
        achievementTitle:  "Bank Savings of $5000 and Retirement Savings of $50,000",
        earnedAchievementDesc: "You have saved $5000 in your bank savings and $50,000 in your retirement (401k) savings account.",
        unearnedAchievementDesc: "Open a bank and retirement savings account and deposit money in each of the accounts. ", 
        criteriaArr: [  
          {amount: "5000", operation: "GE", dataName: "bankSavings", displayName: "bank savings amount", 
            displayNA: "bank savings", amountType: "amount"},
          {amount: "50000", operation: "GE", dataName: "retirementSavings", displayName: "retirement savings amount", 
            displayNA: "retirement savings", amountType: "amount"}],
        monthCriteria: {nbrMonths: "0", monthType: "none"},
        link: "unlocked-features", linkSelect: "Money Builder"
    },
    {
        achievementID: "S-3",
        achievementName: "Silver #3",
        achievementTitle:  "Diversified Investments",
        earnedAchievementDesc: "Your portfolio is diversied (mixed). You own some stocks and some " +
          "bonds ...or... a 'balanced' index or mutual fund.",
        unearnedAchievementDesc: "Your portfolio is not currently diversied (mixed).  You need to own " +
          "some stocks and some bonds ...or... a 'balanced' index or mutual fund.",
        criteriaArr: [{amount: "2", operation: "GE", dataName: "investmentMix",
            displayName: "investments of different types", displayNA: "investments", amountType: "number" }],
        monthCriteria: {nbrMonths: "0", monthType: "none"},
        link: "unlocked-features", linkSelect: "Money Builder"
    },
    {
        achievementID: "S-4",
        achievementName: "Silver #4",
        achievementTitle:  "Credit card and loan amount less than 36% of income for 1 year.",
        earnedAchievementDesc: "Your total credit card and monthly loan amount is less than 36% of your monthly income.",
        unearnedAchievementDesc:  "Your total credit card and monthly loan amount must be less than 36% " +
          "of your monthly income.",
        criteriaArr: [
            {amount: "36", operation: "LT", dataName: "totalDebt", displayName: "credit card and loan amounts", 
              displayNA: "total debt", amountType: "percent", pctBase: "grossIncome"}
        ],
        monthCriteria: {nbrMonths: "12", monthType: "consecutive"},
        link: "monthly-status"
    },
    {
        achievementID: "G-1",
        achievementName: "Gold #1",
        achievementTitle:  "Cash Flow GT $0 for 5 Years",
        earnedAchievementDesc: "You have been making more income than you have spent for at " +
          "least 1 year.",
        unearnedAchievementDes: "Make more money than you spend for 1 year.",
        criteriaArr: [{amount: "0", operation: "GT", dataName: "netIncome", displayName: "cash flow", 
          amountType: "amount"  }],
        monthCriteria: {nbrMonths: "60", monthType: "consecutive"},
        link: "monthly-status"
    },
     {
        achievementID: "G-2",
        achievementName: "Gold #2",
        achievementTitle:  "Achieved Emergency Fund and Retirement Goal",
        earnedAchievementDesc: "Your bank savings has met or exceeded the amount recommended for an " +
          "emergency fund (3 times average monthly expenses) and your retirement (401k) savings is more " +
          "than annual salary.",
        unearnedAchievementDesc: "Your bank savings must be GT the amount recommended for an " +
          "emergency fund (3 times monthly expenses) and your retirement savings (401k) must be " +
          "greater than your annual salary (this is the goal for a 30 year old).", 
        criteriaArr: [{amount: "300", operation: "GT", dataName: "bankSavings", displayName: "bank savings", 
            amountType: "percent", pctBase: "expenses"},
            // bankSavings GT (expenses * 300/100)
            {amount: "100", operation: "GT", dataName: "retirementSavings", 
              displayName: "retirement savings", amountType: "percent", pctBase: "annualSalary"  }
          ],
        monthCriteria: {nbrMonths: "0", monthType: "none"},
        link: "monthly-status",
    },
    {
        achievementID: "G-3",
        achievementName: "Gold #3",
        achievementTitle:  "Fully Diversified for 1 Year",
        earnedAchievementDesc: "You have at least 1 stock, 1 bond, 1 index fund, and 1 mutual fund and " +
          "have held them for at least 1 year. Go to the Investments display and check out your earnings.",
        unearnedAchievementDesc: "Purchase at least 1 stock, 1 bond, 1 index fund and 1 mutual fund and " +
          "hold them for at least 1 year.",
        criteriaArr: [{amount: "4", operation: "GE", dataName: "investmentDiverse", 
            displayName: "investments of different types", displayNA: "investments", amountType: "number" }],
        monthCriteria: {nbrMonths: "12", monthType: "consecutive"},
        link: "unlocked-features", linkSelect: "Money Builder"
    },
    {
        achievementID: "G-4",
        achievementName: "Gold #4",
        achievementTitle:  "Excellent Credit Score (above 800)",
        earnedAchievementDesc: "Your credit score has been greater than or equal to 800 for more than 1 year.",
        unearnedAchievementDesc: "Work to increase your credit score so that it is greater than or equal to " +
          "800 for more than 1 year. Check it out in the Monthly Budget display (How am I Doing).",
        criteriaArr: [{amount: "800", operation: "GT", dataName: "creditScore", displayName: "credit score", 
           amountType: "number" }],
        monthCriteria: {nbrMonths: "12", monthType: "consecutive"},
        link: "monthly-status", linkSelect: "Display Your Credit Report"
    },
    {
        achievementID: "J-1",
        achievementName: "Jewel #1",
        achievementTitle:  "Great Retirement Score",
        earnedAchievementDesc: "Your Retirement score is greater than 40000 and you've played for at least 10 years.",
        unearnedAchievementDesc: "Your Retirement score must be greater than 40000 and play the game for at " +
          "least 10 years.",
        criteriaArr: [{amount: "40000", operation: "GE", dataName: "retirementScore",
            displayName: "retirement score", amountType: "number" }],
        monthCriteria: {nbrMonths: "120", monthType: "monthsPlayed"},
        link: "status-display", linkSelect: "Mood and Retirement Status"
    },
    {
        achievementID: "J-2",
        achievementName: "Jewell #2 - Bragging Rights!!",
        achievementTitle:  "Great Mood Score",
        earnedAchievementDesc: "Your Mood Score is greater than 40000 and you've played for at least 10 years.",
        unearnedAchievementDesc: "Your Mood Score must be greater than 40000 and play the game for at " +
          "least 10 years.",
        criteriaArr: [{amount: "40000", operation: "GE", dataName: "moodScore",
            displayName: "mood score", amountType: "number"  }],
        monthCriteria: {nbrMonths: "120", monthType: "monthsPlayed"},
        link: "status-display", linkSelect: "Mood and Retirement Status"
    },
     {
        achievementID: "J-3",
        achievementName: "Jewell #3 - Bragging Rights!!",
        achievementTitle:  "Earned All Badges",
        earnedAchievementDesc: "You have earned all parts of the 8 badges that are supported by the game.",
        unearnedAchievementDesc: "Earn both parts of all 8 badges that are supported by the game.",
        criteriaArr: [{amount: "8", operation: "GE", dataName: "allBadges",
            displayName: "number of badges earned", amountType: "number" }],
        monthCriteria: {nbrMonths: "0", monthType: "none"},
        link: ""
    },
    {   
      achievementID: "J-4",
        achievementName: "Jewell #4 - Bragging Rights!!",
        achievementTitle:  "Great Test Score (GT 90%)",
        earnedAchievementDesc: "Your Test score is greater than 90%.",
        unearnedAchievementDesc: "Your Test Score must be greater than 90%.  To retake the test " +
          "go to Extra Credit and click the Are You Financially Savvy button... OR ... click the link " +
          "below.",
        criteriaArr: [{amount: "90.00", operation: "GT", dataName: "moneyMgmtTest", 
            displayName: "Financial Literacy Test", amountType: "percent" }],
        monthCriteria: {nbrMonths: "0", monthType: "none"},
        link: "money-mgmt-test", linkSelect: ""
    },
   
];

export default AchievementsDataset;